export default __webpack_public_path__ + "static/media/img_jobinfo.eb25e083.png";